import Vue from 'vue'
import Router from 'vue-router'

import LayoutDefault from './layouts/default.vue'

import Login from './views/Login.vue'
import Password from './views/Password.vue'
import PasswordReset from './views/PasswordReset.vue'
import PortefeuilleBien from './views/Portefeuille/Bien.vue'
import PortefeuilleHome from './views/Portefeuille/Home.vue'
import Proprietaire from './views/Proprietaire.vue'
import Welcome from './views/Welcome.vue'
import CGA from './components/Portefeuille/CGA.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: LayoutDefault,
      children: [
        {
          path: '',
          component: Login,
        },
        {
          path: 'password',
          component: Password,
        },
        {
          path: 'password-reset',
          component: PasswordReset,
        },
        
        {
          path: 'welcome',
          component: Welcome,
        },
        {
          path: 'pro',
          component: Proprietaire,
        },
        {
          path: 'portefeuille',
          component: () => import(/* webpackChunkName: "about" */ './views/Portefeuille.vue'),
          children: [
            {
              path: ':portefeuille/:site/:bien',
              component: PortefeuilleBien,
            },
            {
              path: ':portefeuille/:site/:bien/:tab',
              component: PortefeuilleBien,
            },
            {
              path: ':portefeuille',
              component: PortefeuilleHome,
            },
            {
              path: '',
              component: PortefeuilleHome,
            },
            {
              path: 'set-cga-value',
              name: 'SetCGAValue',
              component: CGA,
    
            },
            
          ],
        },
        
      ],
    },
  ],
})
